import React, { FC } from 'react';

import { usePermissions } from '~/hooks';
import { usePageShow } from '~/hooks/usePageQuery';
import { locations } from '~/routes';
import { MapMarker, GoogleMap } from '~/components';
import { useAllLocations } from '~/hooks/locations';

const Map: FC = () => {
  const allLocationsQuery = useAllLocations();
  const hasAccess = usePermissions('business.location.view');
  const { showOpen } = usePageShow(locations);
  const handleOpen = (id: string) => () => hasAccess && showOpen(id);

  const markers = allLocationsQuery.data
    ?.filter((item) => item.address?.geolocation?.latitude && item.address.geolocation.longitude)
    .map((item) => (
      <MapMarker
        key={item.id}
        name={item.name}
        lat={item.address!.geolocation!.latitude}
        lng={item.address!.geolocation!.longitude}
        onClick={handleOpen(item.id!)}
      />
    ));

  return (
    <div style={{ height: 'calc(100vh - 64px)', width: '100%' }}>
      <GoogleMap
        options={{
          fullscreenControl: false,
        }}
      >
        {markers}
      </GoogleMap>
    </div>
  );
};

export default Map;
